/**
 * SEO Page Configuration
 *
 * Single source of truth for all page SEO data.
 * Used by:
 * - React components (SeoTags)
 * - generate-seo-pages.js (static HTML generation)
 * - generate-sitemap.js (sitemap generation)
 */

import {
  organizationSchema,
  webSiteSchema,
  breadcrumbBrand,
  breadcrumbBrandVc
} from './schemas'

/**
 * Default SEO values (used for homepage and fallback)
 */
export const DEFAULT_SEO = {
  path: '/',
  title: "LinkPool | Leading the Crypto Ecosystem's Next Evolution",
  description:
    "LinkPool is leading the crypto ecosystem's next evolution with enterprise-grade Web3 infrastructure, liquid staking, and onchain finance solutions.",
  keywords:
    'LinkPool, Web3, Crypto, Blockchain, Liquid Staking, Enterprise, Decentralised, Onchain Finance',
  ogImage: '/og.png',
  schemas: [organizationSchema, webSiteSchema],
  sitemapPriority: 1.0,
  sitemapChangefreq: 'weekly'
}

/**
 * SEO configuration for all pages
 */
export const SEO_PAGES = [
  // Homepage
  DEFAULT_SEO,

  // Brand Assets
  {
    path: '/brand',
    title: 'Brand Assets | LinkPool',
    description:
      'Download official LinkPool brand assets including logos, colors, and guidelines for media and partnerships.',
    keywords: 'LinkPool logo, brand assets, media kit, LinkPool branding',
    ogImage: '/og.png',
    schemas: [breadcrumbBrand, organizationSchema],
    sitemapPriority: 0.5,
    sitemapChangefreq: 'monthly'
  },

  // Brand Assets - VC
  {
    path: '/brand-linkpool-vc',
    title: 'LinkPool Ventures Brand Assets | LinkPool',
    description:
      'Download official LinkPool Ventures brand assets including logos, colors, and guidelines for media and partnerships.',
    keywords:
      'LinkPool Ventures logo, brand assets, media kit, LinkPool Ventures branding',
    ogImage: '/og.png',
    schemas: [breadcrumbBrandVc, organizationSchema],
    sitemapPriority: 0.5,
    sitemapChangefreq: 'monthly'
  }
]

/**
 * Get SEO config by path
 */
export function getSeoByPath(path) {
  return SEO_PAGES.find((page) => page.path === path) || DEFAULT_SEO
}
